// TabaPay SDK will be loaded dynamically
declare global {
  interface Window {
    tabaPaySdk: any;
  }
}

export const createIFrame = (
  onFocusChange: (focused: boolean) => void,
  onSubmit: (data: any) => void,
  onCancel: () => void,
) => {
  // console.log('🚀 === createIFrame function called ===');
  // console.log('📥 Parameters received:', {
  //     onFocusChange: typeof onFocusChange,
  //     onSubmit: typeof onSubmit,
  //     onCancel: typeof onCancel,
  //     onFocusChangeFunction: onFocusChange.toString().substring(0, 100) + '...',
  //     onSubmitFunction: onSubmit.toString().substring(0, 100) + '...',
  //     onCancelFunction: onCancel.toString().substring(0, 100) + '...'
  // });

  // console.log('🔍 Checking TabaPay SDK availability...');
  // console.log('window.tabaPaySdk exists:', !!window.tabaPaySdk);
  // console.log('window.tabaPaySdk type:', typeof window.tabaPaySdk);

  // if (window.tabaPaySdk) {
  //     console.log('TabaPay SDK methods available:', Object.keys(window.tabaPaySdk));
  //     console.log('createIframe method exists:', typeof window.tabaPaySdk.createIframe);
  // }

  if (!window.tabaPaySdk) {
    console.error("❌ TabaPay SDK not found in window object");
    throw new Error("TabaPay SDK not loaded");
  }

  try {
    const clientId = process.env.REACT_APP_TABAPAY_CLIENTID;
    console.log(
      "🔑 Client ID:",
      clientId ? `${clientId.substring(0, 10)}...` : "NOT SET",
    );

    const iframeConfig = {
      intrinsicWidth: 420,
      layout: "default",
      cardNumberInput: {
        separator: "-",
        cardLogo: "inside",
        invalidTextPosition: "bottom-right",
        labelText: "Card Number",
        placeholderText: "0000-0000-0000-0000",
      },
      expirationDateInput: {
        labelText: "Expires",
        placeholderText: "MM/YY",
      },
      cscInput: {
        labelText: "CVV",
        placeholderText: "123",
      },
      /*buttons: {
                submit: {
                    order: '1',
                },
                reset: {
                    order: '2',
                },
                cancel: {
                    order: '3',
                },
            },*/
      buttons: {
        layout: "row",
        placement: "end",
        gap: "12px",
        submit: {
          backgroundColorEnabled: "#304BBA",
          backgroundColorHover: "#253A92",
          backgroundColorDisabled: "#E0E0E0",
          textColorEnabled: "#ffffff",
          textColorDisabled: "#999999",
          textColorHover: "#ffffff",
          borderRadius: "6px",
          border: "none",
          fontFamily: '"Roboto", sans-serif',
          fontSize: "14px",
          fontWeight: "500",
          padding: "10px 24px",
          height: "40px",
          buttonText: "Add card",
          order: "2",
        },
        cancel: {
          backgroundColorEnabled: "#ffffff",
          backgroundColorHover: "#F5F5F5",
          textColorEnabled: "#304BBA",
          textColorHover: "#253A92",
          borderRadius: "6px",
          border: "1px solid #304BBA",
          borderColorHover: "#253A92",
          fontFamily: '"Roboto", sans-serif',
          fontSize: "14px",
          fontWeight: "500",
          padding: "10px 24px",
          height: "40px",
          buttonText: "Cancel",
          order: "1",
        },
      },
      labelStyle: {
        placement: "above",
        fontWeight: "500",
        fontFamily: '"Roboto", sans-serif',
        fontSize: "14px",
        textColor: "#333333",
        gap: "8px",
        invalidTextColor: "#E34850",
      },
      inputStyle: {
        textColor: "#333333",
        placeholderTextColor: "#999999",
        backgroundColor: "#F8F9FA",
        borderRadius: "6px",
        borderColor: "#D2D6DD",
        borderStyle: "1px solid",
        borderFocus: "1px solid",
        borderColorFocus: "#304BBA",
        backgroundColorFocus: "#FFFFFF",
        fontFamily: '"Roboto", sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        padding: "12px 16px",
        invalidBackgroundColor: "#FBE4E6",
        invalidBorderColor: "#E34850",
        invalidBorderFocus: "1px solid",
        invalidBorderColorFocus: "#E34850",
        boxShadow: "none",
        boxShadowFocus: "0 0 0 3px rgba(48, 75, 186, 0.1)",
      },
      insetFrame: {
        backgroundColor: "#FFFFFF",
        minWidth: "280px",
        minHeight: "280px",
        maxWidth: "100%",
        maxHeight: "100%",
      },
      formRowGap: "14px",
      formHorizontalGap: "10px",
      padding: "16px 12px",
      margin: "0",
      eventListeners: {
        focusChange: onFocusChange,
        submit: onSubmit,
        cancel: onCancel,
      },
      clientId: clientId,
    };

    // console.log('⚙️ Iframe configuration:', {
    //     intrinsicWidth: iframeConfig.intrinsicWidth,
    //     cardNumberInput: iframeConfig.cardNumberInput,
    //     expirationDateInput: iframeConfig.expirationDateInput,
    //     cscInput: iframeConfig.cscInput,
    //     buttons: iframeConfig.buttons,
    //     hasEventListeners: !!iframeConfig.eventListeners,
    //     clientIdSet: !!iframeConfig.clientId
    // });

    //debug
    // console.log('🔧 Calling window.tabaPaySdk.createIframe...');
    const result = window.tabaPaySdk.createIframe(iframeConfig);

    //debug
    // console.log('✅ createIframe result:', {
    //     resultType: typeof result,
    //     resultKeys: result ? Object.keys(result) : 'null/undefined',
    //     hasElement: !!(result && result.element),
    //     elementType: result && result.element ? result.element.tagName : 'no element'
    // });

    // if (result && result.element) {
    //     console.log('📐 Iframe element details:', {
    //         tagName: result.element.tagName,
    //         className: result.element.className,
    //         id: result.element.id,
    //         src: result.element.src || 'no src',
    //         width: result.element.width || result.element.style.width,
    //         height: result.element.height || result.element.style.height
    //     });
    // }

    console.log("🎉 createIFrame completed successfully");
    return result;
  } catch (error) {
    console.error("💥 Error in createIframe:", error);

    throw error;
  }
};

export const loadTabaPaySDK = () => {
  return new Promise((resolve, reject) => {
    if (window.tabaPaySdk) {
      console.log("TabaPay SDK already loaded");
      resolve(window.tabaPaySdk);
      return;
    }

    const script = document.createElement("script");
    script.src =
      process.env.REACT_APP_TABAPAY_SDK ||
      "https://iframes.sandbox.tabapay.net/TabaPaySDK.js";
    script.async = true;
    script.onload = () => {
      console.log("TabaPay SDK script loaded");
      resolve(window.tabaPaySdk);
    };
    script.onerror = (error) => {
      console.error("Failed to load TabaPay SDK script:", error);
      reject(new Error("Failed to load TabaPay SDK"));
    };
    document.head.appendChild(script);
  });
};
